export default "/vietnamese.d107f726-971078.woff2";